import SpyderAxiosConfig from './spyderAxiosConfig'
import firebase from '../config/FirebaseConfig'

// Pages through either with a cursor (from the previous response's `next`) or a page number, not both.
// Page numbers only reach the first 10,000 results.
const searchSpyderBrands = async (searchTerm, pagination = { cursor: null, page: null, limit: 10 }) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { cursor, page, limit = 10 } = pagination
  const params = { limit }
  // Without a search term, brands are returned sorted by popularity
  if (searchTerm) params.search = searchTerm
  if (cursor) params.cursor = cursor
  else if (page) params.page = page

  const result = await SpyderAxiosConfig.get(
    '/brands',
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  // Result has schema: { data: [...], next: string, total: number }
  return result
}

const getAutocompleteResults = async (searchTerm) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const params = { search: searchTerm }

  const { data } = await SpyderAxiosConfig.get(
    '/discovery/auto-complete',
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  searchSpyderBrands,
  getAutocompleteResults
}